"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));

var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));

var _Avatar = _interopRequireDefault(require("./Avatar"));

var _default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default,
    Avatar: _Avatar.default
  },
  props: ['network', 'user', 'nicklist'],
  computed: {
    userColour: function userColour() {
      if (this.nicklist.useColouredNicks) {
        return this.user.getColour();
      }

      return '';
    },
    shouldShowAvatars: function shouldShowAvatars() {
      return this.nicklist.buffer.setting('nicklist_avatars');
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;
